module.exports = __webpack_public_path__ + "img/lume_hover.3c0b34eb.png";